import React, {useEffect, useRef, useState, useMemo} from 'react';
import {MainStateMachineProvider} from "../MainStateMachineProvider";
import {ErrorsManager} from "../ErrorsManager/ErrorsManager";
import {ProgressBarManager} from "../ProgressBarManager/ProgressBarManager";
import {FrameManager} from "../FrameManager/FrameManager";
import {PaginationManager} from "../PaginationManager/PaginationManager";
import {ScenarioSettingsModal} from "../ScenarioSettings/ScenarioSettingsModal";
// import {MdSettings} from "react-icons/md";

import css from "./PlayerScenario.module.css"
import {useParams} from "react-router-dom";

const PlayerScenario = () => {
    let {id, scenarioId} = useParams();
    let wakeLock = useRef(null);
    const [isSettingsVisible, setIsSettingsVisible] = useState(false);

    const playerScenarioObj = useMemo(() => ({id, scenarioId}), [id, scenarioId]);

    useEffect(() => {
        wakeLock.current = requestWakeLock().then();
        return () => {
            if (wakeLock.current) {
                releaseWakeLock(wakeLock.current).then();
            }
        };
    }, []);


    return (
        <MainStateMachineProvider playerScenarioObj={playerScenarioObj}>
            <div className={css.container}>

                {/*<div className={css.settingsTrigger} onClick={() => setIsSettingsVisible(true)}>*/}
                {/*    <MdSettings />*/}
                {/*</div>*/}
                <ErrorsManager/>
                <FrameManager/>
                <ProgressBarManager/>
            </div>
            <PaginationManager/>
            <ScenarioSettingsModal 
                isVisible={isSettingsVisible} 
                onClose={() => setIsSettingsVisible(false)} 
            />
        </MainStateMachineProvider>
    );
};

export {PlayerScenario};


async function requestWakeLock() {
    if (!('wakeLock' in navigator)) {
        console.error('Screen Wake Lock API is not supported by the browser');
        return;
    }
    try {
        const wakeLock = await navigator.wakeLock.request('screen');
        console.log('Wake Lock is active');
        return wakeLock
    } catch (err) {
        console.error(`WakeLock request error: ${err.message}`);
    }
};

async function releaseWakeLock(wakeLock) {
    if (typeof wakeLock === "function") {
        await wakeLock.release();
        console.log('Wake Lock has been released');
        wakeLock = null; // Сбрасываем переменную
    }
};